// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"272":"ddef5865","994":"a0d7a65f"}[chunkId] + ".chunk.css");